import { __extends } from "tslib";
import { PostProcess } from "./postProcess";
import { Engine } from "../Engines/engine";
import "../Shaders/pass.fragment";
import "../Shaders/passCube.fragment";
import { _TypeStore } from '../Misc/typeStore';
import { SerializationHelper } from '../Misc/decorators';
/**
 * PassPostProcess which produces an output the same as it's input
 */
var PassPostProcess = /** @class */ (function (_super) {
    __extends(PassPostProcess, _super);
    /**
     * Creates the PassPostProcess
     * @param name The name of the effect.
     * @param options The required width/height ratio to downsize to before computing the render pass.
     * @param camera The camera to apply the render pass to.
     * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
     * @param engine The engine which the post process will be applied. (default: current engine)
     * @param reusable If the post process can be reused on the same frame. (default: false)
     * @param textureType The type of texture to be used when performing the post processing.
     * @param blockCompilation If compilation of the shader should not be done in the constructor. The updateEffect method can be used to compile the shader at a later time. (default: false)
     */
    function PassPostProcess(name, options, camera, samplingMode, engine, reusable, textureType, blockCompilation) {
        if (camera === void 0) { camera = null; }
        if (textureType === void 0) { textureType = 0; }
        if (blockCompilation === void 0) { blockCompilation = false; }
        return _super.call(this, name, "pass", null, null, options, camera, samplingMode, engine, reusable, undefined, textureType, undefined, null, blockCompilation) || this;
    }
    /**
     * Gets a string identifying the name of the class
     * @returns "PassPostProcess" string
     */
    PassPostProcess.prototype.getClassName = function () {
        return "PassPostProcess";
    };
    /** @hidden */
    PassPostProcess._Parse = function (parsedPostProcess, targetCamera, scene, rootUrl) {
        return SerializationHelper.Parse(function () {
            return new PassPostProcess(parsedPostProcess.name, parsedPostProcess.options, targetCamera, parsedPostProcess.renderTargetSamplingMode, scene.getEngine(), parsedPostProcess.reusable);
        }, parsedPostProcess, scene, rootUrl);
    };
    return PassPostProcess;
}(PostProcess));
export { PassPostProcess };
_TypeStore.RegisteredTypes["BABYLON.PassPostProcess"] = PassPostProcess;
/**
 * PassCubePostProcess which produces an output the same as it's input (which must be a cube texture)
 */
var PassCubePostProcess = /** @class */ (function (_super) {
    __extends(PassCubePostProcess, _super);
    /**
     * Creates the PassCubePostProcess
     * @param name The name of the effect.
     * @param options The required width/height ratio to downsize to before computing the render pass.
     * @param camera The camera to apply the render pass to.
     * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
     * @param engine The engine which the post process will be applied. (default: current engine)
     * @param reusable If the post process can be reused on the same frame. (default: false)
     * @param textureType The type of texture to be used when performing the post processing.
     * @param blockCompilation If compilation of the shader should not be done in the constructor. The updateEffect method can be used to compile the shader at a later time. (default: false)
     */
    function PassCubePostProcess(name, options, camera, samplingMode, engine, reusable, textureType, blockCompilation) {
        if (camera === void 0) { camera = null; }
        if (textureType === void 0) { textureType = 0; }
        if (blockCompilation === void 0) { blockCompilation = false; }
        var _this = _super.call(this, name, "passCube", null, null, options, camera, samplingMode, engine, reusable, "#define POSITIVEX", textureType, undefined, null, blockCompilation) || this;
        _this._face = 0;
        return _this;
    }
    Object.defineProperty(PassCubePostProcess.prototype, "face", {
        /**
         * Gets or sets the cube face to display.
         *  * 0 is +X
         *  * 1 is -X
         *  * 2 is +Y
         *  * 3 is -Y
         *  * 4 is +Z
         *  * 5 is -Z
         */
        get: function () {
            return this._face;
        },
        set: function (value) {
            if (value < 0 || value > 5) {
                return;
            }
            this._face = value;
            switch (this._face) {
                case 0:
                    this.updateEffect("#define POSITIVEX");
                    break;
                case 1:
                    this.updateEffect("#define NEGATIVEX");
                    break;
                case 2:
                    this.updateEffect("#define POSITIVEY");
                    break;
                case 3:
                    this.updateEffect("#define NEGATIVEY");
                    break;
                case 4:
                    this.updateEffect("#define POSITIVEZ");
                    break;
                case 5:
                    this.updateEffect("#define NEGATIVEZ");
                    break;
            }
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Gets a string identifying the name of the class
     * @returns "PassCubePostProcess" string
     */
    PassCubePostProcess.prototype.getClassName = function () {
        return "PassCubePostProcess";
    };
    /** @hidden */
    PassCubePostProcess._Parse = function (parsedPostProcess, targetCamera, scene, rootUrl) {
        return SerializationHelper.Parse(function () {
            return new PassCubePostProcess(parsedPostProcess.name, parsedPostProcess.options, targetCamera, parsedPostProcess.renderTargetSamplingMode, scene.getEngine(), parsedPostProcess.reusable);
        }, parsedPostProcess, scene, rootUrl);
    };
    return PassCubePostProcess;
}(PostProcess));
export { PassCubePostProcess };
Engine._RescalePostProcessFactory = function (engine) {
    return new PassPostProcess("rescale", 1, null, 2, engine, false, 0);
};
//# sourceMappingURL=passPostProcess.js.map